(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.filesLoader', [])

        .directive('newOrderFilesLoader', function () {
            return {
                restrict: "E",
                templateUrl: 'app/ui/order/newOrderView/newOrderFilesLoader/newOrderFilesLoader.html',
                scope: {
                    files: "="
                },
                controller: 'NewOrderFilesLoaderController',
                link: function (scope, el, attrs) {  // eslint-disable-line no-unused-vars
                    scope.fileInputElement = el.find("#new-order-file-input");
                    scope.fileInputElement.on('change', function (e) {
                        scope.$apply(function () {
                            scope.filesSelected(e.target.files);
                        });
                        scope.fileInputElement.val("");
                    });

                    var fileUploadElement = el.find("#new-order-file-upload");
                    jQuery.event.props.push('dataTransfer');
                    fileUploadElement.on("dragover", function () {
                        fileUploadElement.addClass('drag-hover');
                        return false;
                    });
                    fileUploadElement.on("dragleave", function () {
                        fileUploadElement.removeClass('drag-hover');
                        return false;
                    });
                    fileUploadElement.on("drop", function (e) {
                        scope.$apply(function () {
                            scope.filesSelected(e.dataTransfer.files);
                        });
                        e.preventDefault();
                        fileUploadElement.removeClass('drag-hover');
                        fileUploadElement.addClass('drag-drop');
                    });
                }
            };
        })

        .controller('NewOrderFilesLoaderController', function ($scope, uiLocalization) {
            angular.extend($scope, {
                openFileDialog: openFileDialog,
                filesSelected: filesSelected,
                onRemoveFileClick: onRemoveFileClick
            });

            $scope.files = [];

            function openFileDialog(e) { // eslint-disable-line no-unused-vars
                $scope.fileInputElement.click();
            }

            function filesSelected(files) {
                angular.forEach(files, function (file) {
                    if (findFileIndex(file) < 0) {
                        $scope.files.push(file);
                    }
                })
            }

            function onRemoveFileClick(file) {
                var message = _.str.sprintf(uiLocalization.translate("Remove %s"), file.name);
                kendo.confirm(message).done(function () {
                    removeFile(file);
                });
            }

            function removeFile(file) {
                var fileIndex = findFileIndex(file);
                if (fileIndex >= 0) {
                    $scope.$apply(function () {
                        $scope.files.splice(fileIndex, 1);
                    });
                }
            }

            function findFileIndex(file) {
                return _.findIndex($scope.files, function (storedFile) {
                    return file.name === storedFile.name && file.size === storedFile.size;
                });
            }
        })
    ;
})(window.angular);
